(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@openhps/core"));
	else if(typeof define === 'function' && define.amd)
		define(["@openhps/core"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("@openhps/core")) : factory(root["@openhps/core"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})((typeof self !== 'undefined' ? self : this), (__WEBPACK_EXTERNAL_MODULE____) => {
return 